import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: true,
    },
    wrapperProps: {
      clipDisabled: true,
      mobileWrapperStyles: css`
        padding-bottom: 30px;
        padding-top: 15px;
      `,
      tabletWrapperStyles: css`
        padding-bottom: 100px;
        padding-top: 40px;
      `,
      desktopWrapperStyles: css`
        padding-bottom: 190px;
        padding-top: 120px;
      `,
    },
    containerProps: {
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: null,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: null,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      imageMobile: null,
      imageTablet: null,
      imageDesktop: null,
      mobileImageWrapperStyles: null,
      tabletImageWrapperStyles: null,
      desktopImageWrapperStyles: null,
      mobileImageStyles: null,
      tabletImageStyles: null,
      desktopImageStyles: null,
    },
  }
}
